import { render, staticRenderFns } from "./PlatformTextArea.vue?vue&type=template&id=9b08bfca&scoped=true"
import script from "./PlatformTextArea.vue?vue&type=script&lang=ts"
export * from "./PlatformTextArea.vue?vue&type=script&lang=ts"
import style0 from "./PlatformTextArea.vue?vue&type=style&index=0&id=9b08bfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b08bfca",
  null
  
)

export default component.exports